module.exports = __webpack_public_path__ + "img/guide_ot2.b0024a98.jpg";